import { ItemList } from '../orm'

class DashboardList extends ItemList {
    getEntityKey() {
        return "dashboard"
    }
}

export const dashboardList = new DashboardList("dashboard__default")
